/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1ClassroomdisciplineSharedDisciplines200,
  GetApiV1ClassroomdisciplineSharedDisciplines401,
  GetApiV1ClassroomdisciplineSharedDisciplinesQueryParams,
  GetApiV1ClassroomdisciplineSharedDisciplinesQueryResponse,
} from "../../types/classPlanningSharedController/GetApiV1ClassroomdisciplineSharedDisciplines.ts";
import { dropDownListViewModelSchema } from "../dropDownListViewModelSchema.ts";

export const getApiV1ClassroomdisciplineSharedDisciplinesQueryParamsSchema = z
  .object({
    Search: z.optional(z.string()),
    Take: z.optional(z.coerce.number().int()),
    Culture: z.optional(z.string()),
    CourseId: z.optional(z.coerce.number().int()),
  })
  .optional() as unknown as ToZod<GetApiV1ClassroomdisciplineSharedDisciplinesQueryParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1ClassroomdisciplineSharedDisciplines200Schema = z.array(
  z.lazy(() => dropDownListViewModelSchema),
) as unknown as ToZod<GetApiV1ClassroomdisciplineSharedDisciplines200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1ClassroomdisciplineSharedDisciplines401Schema =
  z.any() as unknown as ToZod<GetApiV1ClassroomdisciplineSharedDisciplines401>;

export const getApiV1ClassroomdisciplineSharedDisciplinesQueryResponseSchema =
  z.lazy(
    () => getApiV1ClassroomdisciplineSharedDisciplines200Schema,
  ) as unknown as ToZod<GetApiV1ClassroomdisciplineSharedDisciplinesQueryResponse>;
